import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { Kevlar2ProgressComponent } from './kevlar2-progress.component';
import { Authority } from '@app/shared/utils/enums';

export const kevlar2ProgressRoutes: Routes = [
    {
        path: 'kevlar2-progress',
        children: [
            {
                path: '',
                component: Kevlar2ProgressComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]